module.exports = __webpack_public_path__ + "img/img-contact-01.44e3ccaa.jpg";